import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, resolveDirective as _resolveDirective, withDirectives as _withDirectives } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "m-quickSearchResults"
}
const _hoisted_2 = { class: "m-quickSearchResults__suggestionList" }
const _hoisted_3 = ["href", "onClick"]
const _hoisted_4 = { class: "m-quickSearchResults__suggestionListItemIcon" }
const _hoisted_5 = ["innerHTML"]
const _hoisted_6 = ["href"]
const _hoisted_7 = {
  key: 1,
  class: "m-quickSearchResults__empty"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_IconComponent = _resolveComponent("IconComponent")!
  const _directive_translate = _resolveDirective("translate")!

  return (_ctx.results)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        (_ctx.results.length > 0)
          ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
              _createElementVNode("ul", _hoisted_2, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.results, (item, idx) => {
                  return (_openBlock(), _createElementBlock("li", {
                    key: idx,
                    class: "m-quickSearchResults__suggestionListItem"
                  }, [
                    _createElementVNode("a", {
                      href: item.url,
                      onClick: ($event: any) => (_ctx.updateSearch(item, $event))
                    }, [
                      _createElementVNode("span", _hoisted_4, [
                        (item.type === 'search')
                          ? (_openBlock(), _createBlock(_component_IconComponent, {
                              key: 0,
                              "icon-id": _ctx.IconName.Search
                            }, null, 8, ["icon-id"]))
                          : (_openBlock(), _createBlock(_component_IconComponent, {
                              key: 1,
                              "icon-id": _ctx.IconName.Calendar
                            }, null, 8, ["icon-id"]))
                      ]),
                      _createElementVNode("span", {
                        class: "m-quickSearchResults__suggestionListItemText",
                        innerHTML: item.title
                      }, null, 8, _hoisted_5)
                    ], 8, _hoisted_3)
                  ]))
                }), 128))
              ]),
              _withDirectives(_createElementVNode("a", {
                class: "a-btnCta -action",
                href: _ctx.searchUrl + '?' + _ctx.searchParam + '=' + _ctx.query
              }, null, 8, _hoisted_6), [
                [_directive_translate, { key: _ctx.Translation.More_search_results }]
              ])
            ], 64))
          : (_ctx.results.length === 0)
            ? _withDirectives((_openBlock(), _createElementBlock("p", _hoisted_7, null, 512)), [
                [_directive_translate, { key: _ctx.Translation.No_search_results }]
              ])
            : _createCommentVNode("", true)
      ]))
    : _createCommentVNode("", true)
}